















import Vue from 'vue'
import firebaseApp from '@/firebaseApp'
import auth from '@/firebaseApp'

export default Vue.extend({
  name: 'OwnerNewStaff',
  data() {
    return {
      staffEmail: null,
      restaurantId: null as string | null,
    }
  },
  created() {
    this.restaurantId = this.$route.params.restaurantId
  },
  methods: {
    async saveStaff() {
      if (!this.staffEmail) {
        alert(this.$i18n.t('owner.newStaff.alertEmail'))
        return
      }

      if (!this.restaurantId) {
        return
      }

      const addUser = firebaseApp.functions('europe-west1').httpsCallable('addUser')
      try {
        const result = await addUser({
          email: this.staffEmail,
          restaurantId: this.restaurantId,
          role: 'staff',
        })

        if (result?.data?.uid) {
          const continueUrl = `${window.config.baseUrl}/${this.restaurantId}/staff`
          await auth.auth().sendPasswordResetEmail(result?.data?.email, {
            url: continueUrl,
          })
        }

        window.location.reload()
      } catch (err) {
        console.error(this.$i18n.t('owner.newStaff.alertError'), err)
        alert(this.$i18n.t('owner.newStaff.alertError'))
      }
    },
  },
  computed: {
    isFormValid() {
      return this.staffEmail && this.staffEmail.indexOf('@') !== -1
    },
  },
})
